type ArrowForwardIosIconProps = React.SVGProps<SVGSVGElement>;

export const ArrowForwardIosIcon: React.FC<ArrowForwardIosIconProps> = (
  props
) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.23 20.23L8 22L18 12L8 2L6.23 3.77L14.46 12L6.23 20.23Z"
      fill="#424242"
    />
  </svg>
);
